import script from "./HarvestCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./HarvestCollection.vue?vue&type=script&setup=true&lang=js"

export default script